export default __webpack_public_path__ + "static/media/message_box_icon.93c8c394.svg";